import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import CalcApp from './components/CalcApp'


ReactDOM.render(
  <React.StrictMode>
    <CalcApp />,
  </React.StrictMode>,
  document.getElementById('root')
)
